import React, {useState} from "react";
import {ProductState} from "../../interfaces/ProductComponentState";
import StateModalModel from "../../../../components/Modal/Model/StateModalModel";
import ModalComponents from "../../../../components/Modal/Modal";
import ModalBody from "./ImageZoom/view/modalBody";
import BtnAddToCart from "./BtnAddToCart/BtnAddToCart";
import AppSettingController from "../../../Main/controller/AppSettingController";
import placeholderImage from "../../assets/img/placeholder.png";
import {useTranslation} from "react-i18next";


export default function ProductGrid({item}: { item: ProductState }) {
    const {i18n} = useTranslation();
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    const [stateModal, setStateModal] = useState<StateModalModel>({
        body: <ModalBody item={item}/>,
        closeLabel: "",
        show: false,
        submit(): void {
        },
        submitLabel: "",
        title: ""
    })

    return (
        <>
            <div className={'product-container'}>
                <div className={`product-image`}
                     onClick={() => setStateModal({...stateModal, show: true})}
                     style={{backgroundImage: `url(${item.image || placeholderImage})`}}/>
                <div className={"product-info"}>
                    <div className={"product-description"}>
                        <h1>{item.title}</h1>
                    </div>
                    {AppSettingController.isActiveCart() ? <div className={"product-price"}>
                        <data value={item.price}
                              style={{visibility: AppSettingController.isHiddenPrice() ? "hidden" : "visible"}}>
                            {item.price.toLocaleString(lang)}
                            <bdi>{item.currency}</bdi>
                        </data>
                        <div>
                            <BtnAddToCart item={item}/>
                        </div>
                    </div> : null}
                </div>
            </div>
            <ModalComponents state={stateModal} setState={setStateModal}/>
        </>
    )
}